import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
export const GetClarifyingQuestionMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ClarifyingQuestionMessage = (param)=>{
    let { content, messageId, onSubmitFeedback, onDismissFeedback } = param;
    const { ClarifyingQuestionMessageTID } = useMemo(()=>GetClarifyingQuestionMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": ClarifyingQuestionMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: ClarifyingQuestionMessageTID.Intro(),
                showWhiteSpaces: true,
                applyMarkdownBold: true,
                children: content.intro
            }),
            /*#__PURE__*/ _jsx(Typography, {
                testId: ClarifyingQuestionMessageTID.Question(),
                showWhiteSpaces: true,
                applyMarkdownBold: true,
                children: content.question
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
